module.exports = __webpack_public_path__ + "static/media/logo-philips-landscape-2.6dc3c0c7.svg";